// extracted by css-extract-rspack-plugin
export default {"root":"root-yisQV_","email":"email-t8JdBE text-body-base mt-base"};